$(document).ready(function() {
    const $carouselsInfoteka = $('.gallery-block__inner');

    const initCarousel = (carousels, config, callback = null) => {
        const defaultConfig = {
            loop: true,
            autoplay: false,
            nav: true,
            dots: true,
            dotsEach: true,
            navText: [
                '<img src="/build/img/landing/icon/carusel.svg" class="carusel-svg carusel-left" alt="Slide left">',
                '<img src="/build/img/landing/icon/carusel.svg" class="carusel-svg carusel-right" alt="Slide right">',
            ],
        };
        if (carousels.length) {
            carousels.owlCarousel({...defaultConfig, ...config});
            if (callback !== null) {
                callback(carousels);
            }
        }
    };

    const infotekaConfig = {
        items: 3,
        loop: true,
        autoplay: false,
        autoplayHoverPause: false,
        autoplayTimeout: 5000,
        nav: true,
        dots: true,
        dotsEach: true,
        navContainer: '.gallery-block__inner',
        responsiveClass: true,
        responsive: {
            400: {
                items: 1,
                nav: true,
                margin: 14,
            },
            992: {
                items: 1,
                margin: 61,
                nav: true,
            },
            1200: {
                items: 1,
                nav: true,
                margin: 96,
            },
            1920: {
                items: 1,
                nav: true,
                margin: 96,
            },
        },
    };
    initCarousel($carouselsInfoteka, infotekaConfig, (carousels) => {
        const $prevBtn = carousels.find('.owl-prev');
        const $nextBtn = carousels.find('.owl-next');
    });
})







